import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from './config.service';
import {AmaiaResponse, Post} from 'jugacu-lib';

@Injectable({
    providedIn: 'root'
})
export class IdcAPIService {

    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService
    ) {
    }

    public getPosts(
        offset = 0
    ): Promise<AmaiaResponse<Post[]>> {
        return this.httpClient
            .get<AmaiaResponse<Post[]>>(`${this.configService.config.AMAIA_BASE_URL}/api/idc/posts/offset/${offset}`)
            .toPromise();
    }

    public getIdcContentsCount(): Promise<AmaiaResponse<number>> {
        return this.httpClient
            .get<AmaiaResponse<number>>(`${this.configService.config.AMAIA_BASE_URL}/api/idc/contents/count`)
            .toPromise();
    }
}
